import { render, staticRenderFns } from "./goodsIn.vue?vue&type=template&id=30c4c5a0&scoped=true&"
import script from "./goodsIn.vue?vue&type=script&lang=js&"
export * from "./goodsIn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30c4c5a0",
  null
  
)

export default component.exports